import MagazineTagPage from '../magazine_tag_page';
import TagPage from '../tag_page';

import tagPageStateManager from '../tag_page_state_manager';

export default function(store) {
  return [
    {
      path: '/magazine/:tag(\\issue-\\d+)',
      component: MagazineTagPage,
      exact: true,
      strict: true,
      loadData: tagPageStateManager(store, 'magazine')
    },
    {
      path: '/magazine/:tag(\\issue-\\d+-\\d+)',
      component: MagazineTagPage,
      exact: true,
      strict: true,
      loadData: tagPageStateManager(store, 'magazine')
    },
    {
      path: '/magazine/:tag',
      component: TagPage,
      exact: true,
      strict: true,
      loadData: tagPageStateManager(store)
    }
  ];
}



// WEBPACK FOOTER //
// ./src/views/containers/pages/tag_page/routes/magazine_tag_page_route.js